export default "__VITE_PUBLIC_ASSET__48c41482__"